import "./CustomPricePerUnitCell.css";

import { useDispatch } from "react-redux";

import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";

import { changeKatsPaperDetailsVisible, selectData, setFormulaRow, setFormulaVisible } from "slices/kats";
import { setClickedTableRow } from "slices/ribbon";

const CustomPricePerUnitCell = ({ rowObj }) => {
	const dispatch = useDispatch();

	const cellTitle = rowObj.cost_doc_5 == null ? "" : rowObj.cost_doc_5.toString();
	const cellValue = <span>{cellTitle}</span>;
	let cellFormula = <></>;
	let justifyContent = "flex-end";

	if ((rowObj.price_offer_unit_formula != null) & (rowObj.price_offer_unit_formula !== "")) {
		cellFormula = (
			<span
				title={rowObj.price_offer_unit_formula}
				onClick={(e) => {
					dispatch(setFormulaRow({ formulaStr: rowObj.price_offer_unit_formula, event: e }));
					dispatch(setFormulaVisible(true));
				}}
			>
				<CalculateOutlinedIcon style={{ fontSize: "14px", position: "relative", top: "1px" }} />
			</span>
		);
		justifyContent = "space-between";
	}

	let height = 15;
	if (rowObj.rowHeightMultiply && rowObj.rowHeightMultiply !== 1) height = 22 * rowObj.rowHeightMultiply;

	return (
		<td
			key={`cell-cost_doc_5-${rowObj.key}`}
			className="TableCell"
			clm="cost_doc_5"
			treecell="false"
			title={cellTitle}
			style={{
				paddingLeft: "3px",
			}}
			onClick={(e) => {
				if (["span", "svg", "path"].includes(String(e.target.tagName).toLocaleLowerCase())) return;

				dispatch(setClickedTableRow({ ...rowObj }));
				dispatch(selectData(rowObj));
				dispatch(changeKatsPaperDetailsVisible({ row: rowObj }));
			}}
		>
			<div
				style={{
					display: "flex",
					justifyContent: justifyContent,
					height: `${height}px`,
					alignItems: "center",
					textAlign: "right",
				}}
			>
				{cellFormula}
				{cellValue}
			</div>
		</td>
	);
};

export default CustomPricePerUnitCell;
